module.exports = __webpack_public_path__ + "static/media/BAllergyClinic.f8ce0d04.png";